'use client';

import { Suspense } from 'react';
import { useRouter, useSearchParams } from 'next/navigation';

const PERIOD_OPTIONS = [
  { label: '7日間', days: 7 },
  { label: '30日間', days: 30 },
  { label: '90日間', days: 90 },
] as const;

function PeriodSelectorInner() {
  const router = useRouter();
  const searchParams = useSearchParams();
  const currentDays = Number(searchParams.get('days')) || 7;

  const handleClick = (days: number) => {
    const params = new URLSearchParams(searchParams.toString());
    params.set('days', String(days));
    router.push(`?${params.toString()}`);
  };

  return (
    <div className="flex gap-2">
      {PERIOD_OPTIONS.map((option) => {
        const isActive = currentDays === option.days;
        return (
          <button
            key={option.days}
            onClick={() => handleClick(option.days)}
            className={
              isActive
                ? 'rounded-lg bg-blue-600 px-4 py-2 text-sm font-medium text-white'
                : 'rounded-lg bg-gray-100 px-4 py-2 text-sm font-medium text-gray-800 hover:bg-gray-200'
            }
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
}

export default function PeriodSelector() {
  return (
    <Suspense
      fallback={
        <div className="flex gap-2">
          {PERIOD_OPTIONS.map((option) => (
            <span
              key={option.days}
              className="rounded-lg bg-gray-100 px-4 py-2 text-sm font-medium text-gray-400"
            >
              {option.label}
            </span>
          ))}
        </div>
      }
    >
      <PeriodSelectorInner />
    </Suspense>
  );
}
